import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"min-width":"600px"}
}
const _hoisted_2 = { class: "modal-content px-10 py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mb-10 pb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "fs-1" }, "Send Credit Below Letter")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "table align-middle table-row-dashed fs-6 gy-3 table-hover"
}
const _hoisted_5 = {
  key: 1,
  class: "pt-5 fs-5"
}
const _hoisted_6 = { class: "d-flex align-items-center mb-7" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800","min-width":"100px"} }, "Account", -1)
const _hoisted_8 = { class: "d-flex align-items-center mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800","min-width":"100px"} }, "Email", -1)
const _hoisted_10 = { class: "d-flex align-items-center mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800","min-width":"100px"} }, "Language", -1)
const _hoisted_12 = { class: "d-flex align-items-center mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800","min-width":"100px"} }, "BCCs", -1)
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = ["value", "disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", { class: "ms-3 me-5" }, "Sales Email:", -1)
const _hoisted_17 = { class: "d-flex align-items-center mt-2" }
const _hoisted_18 = ["value", "disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", { class: "ms-3 me-5" }, "IB Email:", -1)
const _hoisted_20 = { class: "d-flex align-items-center mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", { class: "ms-3 me-5" }, "Dealing Dept:", -1)
const _hoisted_22 = { class: "d-flex align-items-center mb-7" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800","width":"100px"} }, "Date", -1)
const _hoisted_24 = { class: "text-end mt-3" }

import { useI18n } from "vue-i18n";
import { ref, reactive } from "vue";
import { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Field } from "vee-validate";
import { hideModal, showModal } from "@/core/helpers/dom";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import TradeServices from "../services/TradeServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailTargetSelection',
  setup(__props, { expose: __expose }) {

const { t } = useI18n();
const isLoading = ref(true);
const item = ref<any>(null);
const EmailTargetSelectionRef = ref(null);

const formData = ref({
  accountNumber: "",
  email: "",
  language: "",
  bccEmails: [] as any,
  date: "",
});

const send = async () => {
  isLoading.value = true;

  if (!formData.value.language) {
    MsgPrompt.warning("Please select a language");
    isLoading.value = false;
    return;
  }

  // formData.value = {
  //   accountNumber: "123456789",
  //   email: "hanktsou@bacera.com",
  //   language: "en-us",
  //   bccEmails: ["hanktsou@bacera.com"],
  //   date: "2024-07-21",
  // };

  try {
    const res = await TradeServices.sendEquityBelowCreditEmail(formData.value);
    MsgPrompt.success(res.message).then(() => {
      close();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }

  isLoading.value = false;
};

const show = (_item: any) => {
  isLoading.value = true;

  item.value = _item;
  formData.value = {
    accountNumber: _item.accountNumber,
    email: _item.email,
    language: "",
    bccEmails: [],
    date: getCurrentDate(),
  };
  showModal(EmailTargetSelectionRef.value);

  isLoading.value = false;
};

const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const close = () => {
  hideModal(EmailTargetSelectionRef.value);
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "EmailTargetSelectionRef",
    ref: EmailTargetSelectionRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createVNode(_component_LoadingRing)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_el_input, {
                  modelValue: formData.value.accountNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.accountNumber) = $event)),
                  placeholder: "Account Number",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_input, {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                  placeholder: "Email",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.language,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.language) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      key: "en-us",
                      value: "en-us",
                      label: "en-us"
                    }),
                    _createVNode(_component_el_radio, {
                      key: "zh-cn",
                      value: "zh-cn",
                      label: "zh-cn"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.bccEmails) = $event)),
                      type: "checkbox",
                      id: "sales",
                      value: item.value.salesEmail,
                      style: {"width":"15px","height":"15px"},
                      disabled: !item.value.salesEmail
                    }, null, 8, _hoisted_15), [
                      [_vModelCheckbox, formData.value.bccEmails]
                    ]),
                    _hoisted_16,
                    _createTextVNode(_toDisplayString(item.value.salesEmail), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.bccEmails) = $event)),
                      type: "checkbox",
                      id: "ib",
                      value: item.value.agentEmail,
                      style: {"width":"15px","height":"15px"},
                      disabled: !item.value.agentEmail
                    }, null, 8, _hoisted_18), [
                      [_vModelCheckbox, formData.value.bccEmails]
                    ]),
                    _hoisted_19,
                    _createTextVNode(_toDisplayString(item.value.agentEmail), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.bccEmails) = $event)),
                      type: "checkbox",
                      id: "ib",
                      value: "dealing@thebcr.com",
                      style: {"width":"15px","height":"15px"}
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.bccEmails]
                    ]),
                    _hoisted_21,
                    _createTextVNode("dealing@thebcr.com ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_el_date_picker, {
                  modelValue: formData.value.date,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.date) = $event)),
                  type: "date",
                  placeholder: "Pick a day"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_button, {
                  type: "success",
                  disable: isLoading.value,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (send()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                  ]),
                  _: 1
                }, 8, ["disable"])
              ])
            ]))
      ])
    ])
  ], 512))
}
}

})